<template lang="pug">
  
  //- b-container(fluid)
  //- b-button.text-truncate(v-if="notice && notice.pk && !AppState.isStandalone", variant="link", :to="{name: 'notice-detail', params: {pk: notice.pk}}", size="sm", style="max-width: 100%")
  //-   icon.sh-icon(name="exclamation-circle")
  //-   span {{notice.notice_title}}
  div.d-none.d-sm-block.sub-header-wrap(v-if="!AppState.isStandalone")
    b-button(variant="link", :to="{name: 'notice'}", size="sm")
      icon.sh-icon(name="exclamation-circle")
      span {{$t('notice')}}
    b-button(variant="link", size="sm", target="_blank", href="https://linkmemine.freshdesk.com/support/home")
      icon.sh-icon(name="question-circle")
      span FAQ
</template>

<script>
import store from '@/api/store'
import {NoticeAPI} from '@/api'
import {user} from '@/api/access'

export default {
  name: 'sub-header',
  methods: {
    getNotice () {
      let params = {
        by: 'notice_date',
        limit: 1,
        offset: 0,
        order: 'desc',
        search_mode: 'pagination',
        type: 'ko'
      }
      NoticeAPI.get('', {params})
        .then(resp => {
          this.notice = resp.data.objects[0]
          store.set('recent_notice', this.notice)
        })
    },
    openTutorial () {
      this.AppState.$emit('open-tutorial')
    }
  },
  created () {
    let stored = store.get('recent_notice')
    if (stored) {
      this.notice = stored
    } else this.getNotice()
  },
  mounted () {
    try {
      const evt = document.createEvent('HTMLEvents')
      evt.initEvent('resize', true, false)
      window.dispatchEvent(evt)
    } catch (e) {
      console.error(e)
    }
  },
  data () {
    return {
      notice: {},
      license: user().license,
      show: true
    }
  }
}
</script>

<style lang="scss" scoped>
.sub-header-wrap {
  // position: relative;
  // width: 100%;
  .btn-link {
    color: #666;
    &:hover { color: #444 }
  }
}

.sh-icon {
  vertical-align: middle;
  margin-right: 4px;
}

.popover-title {
  font-size: 12px;
  vertical-align: middle;
}

.license-warning-list {
  padding: 0 10px;
  font-size: 12px;
}
</style>
